import * as React from 'react'
import { theme } from '../../theme'
import { ThumbnailGrid } from '../ThumbnailGrid'
import { SavedImage } from '../useSaveImage'

interface Props {
	width: string
	height: string
	savedImages: SavedImage[]
	currentImage: SavedImage | null
	onImageSelect: (image: SavedImage) => void
	onCreateNew: () => void
	onDeleteImage: (imageId: string) => void
	onImageUpload: (file: File) => void
}

export const LeftPanel = ({
	width,
	height,
	savedImages,
	currentImage,
	onImageSelect,
	onCreateNew,
	onDeleteImage,
	onImageUpload,
}: Props) => {
	return (
		<div
			style={{
				backgroundColor: theme.colors.background,
				borderRadius: theme.borderRadius.md,
				width,
				height,
				display: 'flex',
				position: 'relative',
				overflow: 'hidden',
				zIndex: 10000,
				flexDirection: 'column',
				marginRight: '20px', // Creates the gap
			}}
		>
			{/* Header for thumbnails */}
			<div
				style={{
					padding: theme.spacing.md,
					borderBottom: `1px solid ${theme.colors.border}`,
					position: 'relative',
				}}
			>
				<h2
					style={{
						margin: 0,
						marginBottom: '8px',
						fontSize: '20px',
						color: '#2F7B76',
					}}
				>
					Edit Images for This Campaign
				</h2>
				<p
					style={{
						margin: 0,
						fontSize: '14px',
						color: theme.colors.text.secondary,
						lineHeight: '1.4',
					}}
				>
					Select images to enhance with AI-powered editing tools or create new campaign visuals with AI
				</p>
			</div>

			{/* Thumbnails content */}
			<div
				style={{
					flex: 1,
					padding: theme.spacing.md,
					overflowY: 'auto',
					display: 'flex',
					flexDirection: 'column',
					minHeight: 0,
				}}
			>
				<ThumbnailGrid
					images={savedImages}
					activeImageUrl={currentImage?.url}
					activeImageId={currentImage?.id}
					onImageSelect={onImageSelect}
					onCreateNew={onCreateNew}
					onDelete={onDeleteImage}
					onUpload={onImageUpload}
				/>
			</div>
		</div>
	)
}
